<template>
<div class="FULL">
    <WechatMask v-if="!!isWeChat" />
    <DownloadPage v-if="!isWeChat" />
</div>
</template>

<script>
import WechatMask from "./components/wechat.warn.vue";
import DownloadPage from "./components/download.page.vue";
export default {
    name: "App",
    components: {
        WechatMask,
        DownloadPage,
    },
    data: function () {
        return {
            isWeChat: undefined,
        };
    },
    mounted: function () {
        this.isWeChat =
            navigator.userAgent.toLowerCase().indexOf("micromessenger") > -1 ||
            typeof navigator.wxuserAgent !== "undefined";
    },
    computed: {},
    methods: {},
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}

.FULL {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
}
</style>
